import { FC } from 'react';
import { Container, Info, Category, Value, Icon } from './IconInfo.styles';
import { InfoOutlined } from '@mui/icons-material';

export interface IconInfoProps {
	variant?: 'small' | 'large';
	icon: JSX.Element;
	title?: string;
	value?: string;
}

const IconInfo: FC<IconInfoProps> = ({ variant = 'small', icon, title, value }) => {
	return (
		<Container $variant={variant} value={value}>
			<Icon>{icon ?? <InfoOutlined fontSize='inherit' />}</Icon>
			<Info>
				{variant === 'large' ? <Category>{title}</Category> : null}
				<Value>{value}</Value>
			</Info>
		</Container>
	);
};

export default IconInfo;
